
import React, { useState, useEffect, useRef } from 'react';
import { ArrowLeftIcon, AddIcon, DownArrowIcon } from './Icons';
import { apiService } from '../../services/apiService';
import { friendlyAuthError } from '../../utils/authErrors';
import { InlineAlert } from '../../components/InlineAlert';

// TypeScript declaration for dataLayer
declare global {
    interface Window {
        dataLayer?: any[];
    }
}

// GTM Event Tracking Helper
const trackGTMEvent = (eventName: string, eventData?: Record<string, any>) => {
    if (typeof window !== 'undefined' && window.dataLayer) {
        window.dataLayer.push({
            event: eventName,
            ...eventData
        });
    }
};

interface RequestInviteModalProps {
    onClose: () => void;
}

// Countries list with priority countries at top
const COUNTRIES = [
    { value: 'India', label: 'India', isPriority: true },
    { value: 'United States', label: 'United States', isPriority: true },
    { value: 'United Kingdom', label: 'United Kingdom', isPriority: true },
    { value: 'Germany', label: 'Germany', isPriority: true },
    { value: 'Malaysia', label: 'Malaysia', isPriority: true },
    { value: 'separator', label: '──────────', isPriority: false },
    { value: 'Afghanistan', label: 'Afghanistan', isPriority: false },
    { value: 'Albania', label: 'Albania', isPriority: false },
    { value: 'Algeria', label: 'Algeria', isPriority: false },
    { value: 'Andorra', label: 'Andorra', isPriority: false },
    { value: 'Angola', label: 'Angola', isPriority: false },
    { value: 'Argentina', label: 'Argentina', isPriority: false },
    { value: 'Armenia', label: 'Armenia', isPriority: false },
    { value: 'Australia', label: 'Australia', isPriority: false },
    { value: 'Austria', label: 'Austria', isPriority: false },
    { value: 'Azerbaijan', label: 'Azerbaijan', isPriority: false },
    { value: 'Bahamas', label: 'Bahamas', isPriority: false },
    { value: 'Bahrain', label: 'Bahrain', isPriority: false },
    { value: 'Bangladesh', label: 'Bangladesh', isPriority: false },
    { value: 'Barbados', label: 'Barbados', isPriority: false },
    { value: 'Belarus', label: 'Belarus', isPriority: false },
    { value: 'Belgium', label: 'Belgium', isPriority: false },
    { value: 'Belize', label: 'Belize', isPriority: false },
    { value: 'Benin', label: 'Benin', isPriority: false },
    { value: 'Bhutan', label: 'Bhutan', isPriority: false },
    { value: 'Bolivia', label: 'Bolivia', isPriority: false },
    { value: 'Bosnia and Herzegovina', label: 'Bosnia and Herzegovina', isPriority: false },
    { value: 'Botswana', label: 'Botswana', isPriority: false },
    { value: 'Brazil', label: 'Brazil', isPriority: false },
    { value: 'Brunei', label: 'Brunei', isPriority: false },
    { value: 'Bulgaria', label: 'Bulgaria', isPriority: false },
    { value: 'Burkina Faso', label: 'Burkina Faso', isPriority: false },
    { value: 'Burundi', label: 'Burundi', isPriority: false },
    { value: 'Cambodia', label: 'Cambodia', isPriority: false },
    { value: 'Cameroon', label: 'Cameroon', isPriority: false },
    { value: 'Canada', label: 'Canada', isPriority: false },
    { value: 'Cape Verde', label: 'Cape Verde', isPriority: false },
    { value: 'Central African Republic', label: 'Central African Republic', isPriority: false },
    { value: 'Chad', label: 'Chad', isPriority: false },
    { value: 'Chile', label: 'Chile', isPriority: false },
    { value: 'China', label: 'China', isPriority: false },
    { value: 'Colombia', label: 'Colombia', isPriority: false },
    { value: 'Comoros', label: 'Comoros', isPriority: false },
    { value: 'Congo', label: 'Congo', isPriority: false },
    { value: 'Costa Rica', label: 'Costa Rica', isPriority: false },
    { value: 'Croatia', label: 'Croatia', isPriority: false },
    { value: 'Cuba', label: 'Cuba', isPriority: false },
    { value: 'Cyprus', label: 'Cyprus', isPriority: false },
    { value: 'Czech Republic', label: 'Czech Republic', isPriority: false },
    { value: 'Denmark', label: 'Denmark', isPriority: false },
    { value: 'Djibouti', label: 'Djibouti', isPriority: false },
    { value: 'Dominica', label: 'Dominica', isPriority: false },
    { value: 'Dominican Republic', label: 'Dominican Republic', isPriority: false },
    { value: 'East Timor', label: 'East Timor', isPriority: false },
    { value: 'Ecuador', label: 'Ecuador', isPriority: false },
    { value: 'Egypt', label: 'Egypt', isPriority: false },
    { value: 'El Salvador', label: 'El Salvador', isPriority: false },
    { value: 'Equatorial Guinea', label: 'Equatorial Guinea', isPriority: false },
    { value: 'Eritrea', label: 'Eritrea', isPriority: false },
    { value: 'Estonia', label: 'Estonia', isPriority: false },
    { value: 'Ethiopia', label: 'Ethiopia', isPriority: false },
    { value: 'Fiji', label: 'Fiji', isPriority: false },
    { value: 'Finland', label: 'Finland', isPriority: false },
    { value: 'France', label: 'France', isPriority: false },
    { value: 'Gabon', label: 'Gabon', isPriority: false },
    { value: 'Gambia', label: 'Gambia', isPriority: false },
    { value: 'Georgia', label: 'Georgia', isPriority: false },
    { value: 'Ghana', label: 'Ghana', isPriority: false },
    { value: 'Greece', label: 'Greece', isPriority: false },
    { value: 'Grenada', label: 'Grenada', isPriority: false },
    { value: 'Guatemala', label: 'Guatemala', isPriority: false },
    { value: 'Guinea', label: 'Guinea', isPriority: false },
    { value: 'Guinea-Bissau', label: 'Guinea-Bissau', isPriority: false },
    { value: 'Guyana', label: 'Guyana', isPriority: false },
    { value: 'Haiti', label: 'Haiti', isPriority: false },
    { value: 'Honduras', label: 'Honduras', isPriority: false },
    { value: 'Hong Kong', label: 'Hong Kong', isPriority: false },
    { value: 'Hungary', label: 'Hungary', isPriority: false },
    { value: 'Iceland', label: 'Iceland', isPriority: false },
    { value: 'Indonesia', label: 'Indonesia', isPriority: false },
    { value: 'Iran', label: 'Iran', isPriority: false },
    { value: 'Iraq', label: 'Iraq', isPriority: false },
    { value: 'Ireland', label: 'Ireland', isPriority: false },
    { value: 'Israel', label: 'Israel', isPriority: false },
    { value: 'Italy', label: 'Italy', isPriority: false },
    { value: 'Jamaica', label: 'Jamaica', isPriority: false },
    { value: 'Japan', label: 'Japan', isPriority: false },
    { value: 'Jordan', label: 'Jordan', isPriority: false },
    { value: 'Kazakhstan', label: 'Kazakhstan', isPriority: false },
    { value: 'Kenya', label: 'Kenya', isPriority: false },
    { value: 'Kiribati', label: 'Kiribati', isPriority: false },
    { value: 'North Korea', label: 'North Korea', isPriority: false },
    { value: 'South Korea', label: 'South Korea', isPriority: false },
    { value: 'Kuwait', label: 'Kuwait', isPriority: false },
    { value: 'Kyrgyzstan', label: 'Kyrgyzstan', isPriority: false },
    { value: 'Laos', label: 'Laos', isPriority: false },
    { value: 'Latvia', label: 'Latvia', isPriority: false },
    { value: 'Lebanon', label: 'Lebanon', isPriority: false },
    { value: 'Lesotho', label: 'Lesotho', isPriority: false },
    { value: 'Liberia', label: 'Liberia', isPriority: false },
    { value: 'Libya', label: 'Libya', isPriority: false },
    { value: 'Liechtenstein', label: 'Liechtenstein', isPriority: false },
    { value: 'Lithuania', label: 'Lithuania', isPriority: false },
    { value: 'Luxembourg', label: 'Luxembourg', isPriority: false },
    { value: 'Madagascar', label: 'Madagascar', isPriority: false },
    { value: 'Malawi', label: 'Malawi', isPriority: false },
    { value: 'Maldives', label: 'Maldives', isPriority: false },
    { value: 'Mali', label: 'Mali', isPriority: false },
    { value: 'Malta', label: 'Malta', isPriority: false },
    { value: 'Marshall Islands', label: 'Marshall Islands', isPriority: false },
    { value: 'Mauritania', label: 'Mauritania', isPriority: false },
    { value: 'Mauritius', label: 'Mauritius', isPriority: false },
    { value: 'Mexico', label: 'Mexico', isPriority: false },
    { value: 'Micronesia', label: 'Micronesia', isPriority: false },
    { value: 'Moldova', label: 'Moldova', isPriority: false },
    { value: 'Monaco', label: 'Monaco', isPriority: false },
    { value: 'Mongolia', label: 'Mongolia', isPriority: false },
    { value: 'Montenegro', label: 'Montenegro', isPriority: false },
    { value: 'Morocco', label: 'Morocco', isPriority: false },
    { value: 'Mozambique', label: 'Mozambique', isPriority: false },
    { value: 'Myanmar', label: 'Myanmar', isPriority: false },
    { value: 'Namibia', label: 'Namibia', isPriority: false },
    { value: 'Nauru', label: 'Nauru', isPriority: false },
    { value: 'Nepal', label: 'Nepal', isPriority: false },
    { value: 'Netherlands', label: 'Netherlands', isPriority: false },
    { value: 'New Zealand', label: 'New Zealand', isPriority: false },
    { value: 'Nicaragua', label: 'Nicaragua', isPriority: false },
    { value: 'Niger', label: 'Niger', isPriority: false },
    { value: 'Nigeria', label: 'Nigeria', isPriority: false },
    { value: 'Norway', label: 'Norway', isPriority: false },
    { value: 'Oman', label: 'Oman', isPriority: false },
    { value: 'Pakistan', label: 'Pakistan', isPriority: false },
    { value: 'Palau', label: 'Palau', isPriority: false },
    { value: 'Panama', label: 'Panama', isPriority: false },
    { value: 'Papua New Guinea', label: 'Papua New Guinea', isPriority: false },
    { value: 'Paraguay', label: 'Paraguay', isPriority: false },
    { value: 'Peru', label: 'Peru', isPriority: false },
    { value: 'Philippines', label: 'Philippines', isPriority: false },
    { value: 'Poland', label: 'Poland', isPriority: false },
    { value: 'Portugal', label: 'Portugal', isPriority: false },
    { value: 'Qatar', label: 'Qatar', isPriority: false },
    { value: 'Romania', label: 'Romania', isPriority: false },
    { value: 'Russia', label: 'Russia', isPriority: false },
    { value: 'Rwanda', label: 'Rwanda', isPriority: false },
    { value: 'Saint Kitts and Nevis', label: 'Saint Kitts and Nevis', isPriority: false },
    { value: 'Saint Lucia', label: 'Saint Lucia', isPriority: false },
    { value: 'Saint Vincent and the Grenadines', label: 'Saint Vincent and the Grenadines', isPriority: false },
    { value: 'Samoa', label: 'Samoa', isPriority: false },
    { value: 'San Marino', label: 'San Marino', isPriority: false },
    { value: 'Sao Tome and Principe', label: 'Sao Tome and Principe', isPriority: false },
    { value: 'Saudi Arabia', label: 'Saudi Arabia', isPriority: false },
    { value: 'Senegal', label: 'Senegal', isPriority: false },
    { value: 'Serbia', label: 'Serbia', isPriority: false },
    { value: 'Seychelles', label: 'Seychelles', isPriority: false },
    { value: 'Sierra Leone', label: 'Sierra Leone', isPriority: false },
    { value: 'Singapore', label: 'Singapore', isPriority: false },
    { value: 'Slovakia', label: 'Slovakia', isPriority: false },
    { value: 'Slovenia', label: 'Slovenia', isPriority: false },
    { value: 'Solomon Islands', label: 'Solomon Islands', isPriority: false },
    { value: 'Somalia', label: 'Somalia', isPriority: false },
    { value: 'South Africa', label: 'South Africa', isPriority: false },
    { value: 'South Sudan', label: 'South Sudan', isPriority: false },
    { value: 'Spain', label: 'Spain', isPriority: false },
    { value: 'Sri Lanka', label: 'Sri Lanka', isPriority: false },
    { value: 'Sudan', label: 'Sudan', isPriority: false },
    { value: 'Suriname', label: 'Suriname', isPriority: false },
    { value: 'Swaziland', label: 'Swaziland', isPriority: false },
    { value: 'Sweden', label: 'Sweden', isPriority: false },
    { value: 'Switzerland', label: 'Switzerland', isPriority: false },
    { value: 'Syria', label: 'Syria', isPriority: false },
    { value: 'Taiwan', label: 'Taiwan', isPriority: false },
    { value: 'Tajikistan', label: 'Tajikistan', isPriority: false },
    { value: 'Tanzania', label: 'Tanzania', isPriority: false },
    { value: 'Thailand', label: 'Thailand', isPriority: false },
    { value: 'Togo', label: 'Togo', isPriority: false },
    { value: 'Tonga', label: 'Tonga', isPriority: false },
    { value: 'Trinidad and Tobago', label: 'Trinidad and Tobago', isPriority: false },
    { value: 'Tunisia', label: 'Tunisia', isPriority: false },
    { value: 'Turkey', label: 'Turkey', isPriority: false },
    { value: 'Turkmenistan', label: 'Turkmenistan', isPriority: false },
    { value: 'Tuvalu', label: 'Tuvalu', isPriority: false },
    { value: 'Uganda', label: 'Uganda', isPriority: false },
    { value: 'Ukraine', label: 'Ukraine', isPriority: false },
    { value: 'United Arab Emirates', label: 'United Arab Emirates', isPriority: false },
    { value: 'Uruguay', label: 'Uruguay', isPriority: false },
    { value: 'Uzbekistan', label: 'Uzbekistan', isPriority: false },
    { value: 'Vanuatu', label: 'Vanuatu', isPriority: false },
    { value: 'Vatican City', label: 'Vatican City', isPriority: false },
    { value: 'Venezuela', label: 'Venezuela', isPriority: false },
    { value: 'Vietnam', label: 'Vietnam', isPriority: false },
    { value: 'Yemen', label: 'Yemen', isPriority: false },
    { value: 'Zambia', label: 'Zambia', isPriority: false },
    { value: 'Zimbabwe', label: 'Zimbabwe', isPriority: false },
    { value: 'Other', label: 'Other', isPriority: false }
];

const RequestInviteModal: React.FC<RequestInviteModalProps> = ({ onClose }) => {
    const [formState, setFormState] = useState({
        email: '',
        firstName: '',
        lastName: '',
        country: '',
        organisation: '',
        designation: '',
        linkedIn: ''
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');
    const [errorMessage, setErrorMessage] = useState('');
    const [emailStatus, setEmailStatus] = useState<'idle' | 'invalid' | 'checking' | 'exists' | 'available'>('idle');
    const [isCountryDropdownOpen, setIsCountryDropdownOpen] = useState(false);
    const [countrySearchTerm, setCountrySearchTerm] = useState('');
    const dropdownRef = useRef<HTMLDivElement>(null);

    // Email validation regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
    const isFormValid = Object.values(formState).every(field => field && field.trim().length > 0);

    // Filtered countries based on search term
    const filteredCountries = COUNTRIES.filter(country => 
        country.value === 'separator' || 
        country.label.toLowerCase().includes(countrySearchTerm.toLowerCase())
    );

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsCountryDropdownOpen(false);
                setCountrySearchTerm('');
            }
        };

        if (isCountryDropdownOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isCountryDropdownOpen]);

    // Track modal open
    useEffect(() => {
        trackGTMEvent('request_invite_modal_opened', {
            component: 'RequestInviteModal'
        });
    }, []);

    // Email checking effect (similar to LoginModal)
    useEffect(() => {
        const checkEmail = async () => {
            const lowerEmail = formState.email.trim().toLowerCase();
            
            if (lowerEmail === '') {
                setEmailStatus('idle');
                return;
            }
            
            if (!emailRegex.test(lowerEmail)) {
                setEmailStatus('invalid');
                // Track invalid email
                trackGTMEvent('request_invite_email_invalid', {
                    component: 'RequestInviteModal',
                    email: lowerEmail
                });
                return;
            }

            // Check email with API
            setEmailStatus('checking');
            try {
                const response = await apiService.checkEmail(lowerEmail);
                if (response.success && response.data) {
                    if (response.data.exists) {
                        setEmailStatus('exists');
                        // Track email exists
                        trackGTMEvent('request_invite_email_exists', {
                            component: 'RequestInviteModal',
                            email: lowerEmail
                        });
                    } else {
                        setEmailStatus('available');
                        // Track email available
                        trackGTMEvent('request_invite_email_available', {
                            component: 'RequestInviteModal',
                            email: lowerEmail
                        });
                    }
                } else {
                    setEmailStatus('available'); // Default to available on API error
                }
            } catch (error) {
                console.error('Email check failed:', error);
                setEmailStatus('available'); // Default to available on network error
            }
        };

        // Debounce the email check
        const timeoutId = setTimeout(checkEmail, 500);
        return () => clearTimeout(timeoutId);
    }, [formState.email]);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFormState(prevState => ({ ...prevState, [name]: value }));
    };

    const handleCountrySelect = (country: string) => {
        if (country !== 'separator') {
            setFormState(prevState => ({ ...prevState, country }));
            setIsCountryDropdownOpen(false);
            setCountrySearchTerm('');
            // Track country selection
            trackGTMEvent('request_invite_country_selected', {
                component: 'RequestInviteModal',
                country: country
            });
        }
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!isFormValid || isSubmitting) return;

        // If email exists, redirect to login instead of sending invite
        if (emailStatus === 'exists') {
            // Track login instead click
            trackGTMEvent('request_invite_login_instead_clicked', {
                component: 'RequestInviteModal',
                email: formState.email.trim().toLowerCase()
            });
            // Redirect to login - for now we'll close this modal and the parent can handle login
            handleModalClose('outside');
            // TODO: Add proper login redirect when onOpenLogin prop is available
            return;
        }

        // Track form submission attempt
        trackGTMEvent('request_invite_form_submitted', {
            component: 'RequestInviteModal',
            email: formState.email.trim().toLowerCase(),
            country: formState.country,
            has_linkedin: !!formState.linkedIn
        });

        setIsSubmitting(true);
        setSubmitStatus('idle');
        setErrorMessage('');

        try {
            // Normalize email before sending
            const normalizedEmail = formState.email.trim().toLowerCase();
            const response = await apiService.requestInvite({
                first_name: formState.firstName,
                last_name: formState.lastName,
                email: normalizedEmail,
                country: formState.country,
                organisation: formState.organisation,
                designation: formState.designation,
                linkedin_url: formState.linkedIn || undefined,
            });

            if (response.success) {
                setSubmitStatus('success');
                // Track successful submission
                trackGTMEvent('request_invite_submission_success', {
                    component: 'RequestInviteModal',
                    email: normalizedEmail,
                    country: formState.country
                });
                // Close modal after showing success for a moment
                setTimeout(() => {
                    handleModalClose('success');
                }, 2000);
            } else if (response.user_exists && response.action === 'login_required') {
                // User already exists, show login prompt
                setSubmitStatus('error');
                setErrorMessage(response.message || 'An account with this email already exists. Please login instead.');
                
                // Track user exists error
                trackGTMEvent('request_invite_submission_user_exists', {
                    component: 'RequestInviteModal',
                    email: normalizedEmail
                });
                
                // Optionally, you could redirect to login or show a login button
                setTimeout(() => {
                    handleModalClose('outside');
                    // You might want to trigger login modal here
                    // onOpenLogin(); // if you have access to this prop
                }, 3000);
            } else {
                setSubmitStatus('error');
                setErrorMessage(friendlyAuthError(response.error, 'Failed to submit request. Please try again.'));
                // Track submission error
                trackGTMEvent('request_invite_submission_error', {
                    component: 'RequestInviteModal',
                    email: normalizedEmail,
                    error: response.error || 'Unknown error'
                });
            }
        } catch (error) {
            setSubmitStatus('error');
            setErrorMessage('Network error. Please check your connection and try again.');
            // Track network error
            trackGTMEvent('request_invite_submission_network_error', {
                component: 'RequestInviteModal',
                email: formState.email.trim().toLowerCase()
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleModalClose = (reason?: 'back' | 'outside' | 'success') => {
        // Track modal close (only if not already tracked by specific action)
        if (reason !== 'back') {
            trackGTMEvent('request_invite_modal_closed', {
                component: 'RequestInviteModal',
                form_filled: isFormValid,
                email_status: emailStatus,
                close_reason: reason || 'unknown'
            });
        }
        onClose();
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[60] font-space-grotesk p-4" onClick={() => handleModalClose('outside')}>
            <div className="bg-white rounded-2xl shadow-lg w-full max-w-3xl p-8 relative" onClick={e => e.stopPropagation()}>
                <div className="text-center mb-6">
                    <h2 className="text-2xl font-medium text-grayscale-1300">It looks like you’re not registered yet!</h2>
                    <p className="text-sm text-grayscale-1100 font-grotesk mt-1">Share your details to sign up</p>
                </div>
                
                <form className="space-y-4" onSubmit={handleSubmit}>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label htmlFor="firstName" className="block text-xs text-main-text mb-1">First Name</label>
                            <input id="firstName" type="text" name="firstName" onChange={handleInputChange} placeholder="Enter first name" className="w-full p-2.5 text-sm bg-[#F5F5F5] rounded-md placeholder-gray-400 focus:outline-none focus:ring-1 focus:ring-primary-600"/>
                        </div>
                        <div>
                            <label htmlFor="lastName" className="block text-xs text-main-text mb-1">Last Name</label>
                            <input id="lastName" type="text" name="lastName" onChange={handleInputChange} placeholder="Enter last name" className="w-full p-2.5 text-sm bg-[#F5F5F5] rounded-md placeholder-gray-400 focus:outline-none focus:ring-1 focus:ring-primary-600"/>
                        </div>
                    </div>

                    <div>
                        <label htmlFor="email" className="block text-xs text-main-text mb-1">Email</label>
                        <div className="relative">
                            <input 
                                id="email" 
                                type="email" 
                                name="email" 
                                onChange={handleInputChange} 
                                placeholder="Add your email address" 
                                className={`w-full p-2.5 pr-10 text-sm bg-[#F5F5F5] rounded-md placeholder-gray-400 focus:outline-none focus:ring-1 ${
                                    emailStatus === 'invalid' ? 'focus:ring-red-500 border-red-500' :
                                    emailStatus === 'exists' ? 'focus:ring-blue-500 border-blue-500' :
                                    emailStatus === 'available' ? 'focus:ring-green-500 border-green-500' :
                                    'focus:ring-primary-600'
                                }`}
                            />
                            {/* Email status indicator */}
                            <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                                {emailStatus === 'checking' && (
                                    <div className="animate-spin h-4 w-4 border-2 border-primary-600 border-t-transparent rounded-full"></div>
                                )}
                                {emailStatus === 'invalid' && (
                                    <span className="text-red-500 text-sm">❌</span>
                                )}
                                {emailStatus === 'exists' && (
                                    <span className="text-blue-500 text-sm">👤</span>
                                )}
                                {emailStatus === 'available' && (
                                    <span className="text-green-500 text-sm">✅</span>
                                )}
                            </div>
                        </div>
                        {/* Email status message */}
                        {emailStatus === 'invalid' && (
                            <p className="text-red-500 text-xs mt-1">Please enter a valid email address</p>
                        )}
                        {emailStatus === 'exists' && (
                            <p className="text-blue-500 text-xs mt-1">Account exists - click "Login Instead" to sign in</p>
                        )}
                        {emailStatus === 'available' && (
                            <p className="text-green-500 text-xs mt-1">Email available for invitation</p>
                        )}
                    </div>
                    
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        {/* Custom Country Dropdown */}
                        <div className="relative" ref={dropdownRef}>
                            <label htmlFor="country" className="block text-xs text-main-text mb-1">Country</label>
                            <div className="relative">
                                <button
                                    type="button"
                                    onClick={() => setIsCountryDropdownOpen(!isCountryDropdownOpen)}
                                    className={`w-full p-2.5 text-sm bg-[#F5F5F5] rounded-md text-left flex items-center justify-between focus:outline-none focus:ring-1 focus:ring-primary-600 ${
                                        formState.country ? 'text-black' : 'text-gray-400'
                                    }`}
                                >
                                    <span>{formState.country || 'Select a country'}</span>
                                    <span className={`transition-transform duration-200 ${isCountryDropdownOpen ? 'rotate-180' : ''}`}>
                                        <DownArrowIcon />
                                    </span>
                                </button>
                                
                                {/* Dropdown Menu */}
                                {isCountryDropdownOpen && (
                                    <div className="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg">
                                        {/* Search Input */}
                                        <div className="p-2 border-b border-gray-200">
                                            <input
                                                type="text"
                                                placeholder="Search countries..."
                                                value={countrySearchTerm}
                                                onChange={(e) => setCountrySearchTerm(e.target.value)}
                                                className="w-full p-2 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-primary-600"
                                                onClick={(e) => e.stopPropagation()}
                                            />
                                        </div>
                                        
                                        {/* Countries List - Max height with scroll */}
                                        <div className="max-h-[200px] overflow-y-auto">
                                            {filteredCountries.length > 0 ? (
                                                filteredCountries.map((country, index) => (
                                                    country.value === 'separator' ? (
                                                        <div key={index} className="px-4 py-1 text-gray-400 text-center text-xs border-b border-gray-200">
                                                            {country.label}
                                                        </div>
                                                    ) : (
                                                        <button
                                                            key={index}
                                                            type="button"
                                                            onClick={() => handleCountrySelect(country.value)}
                                                            className={`w-full px-4 py-2 text-left text-sm hover:bg-primary-100 focus:bg-primary-100 focus:outline-none ${
                                                                formState.country === country.value ? 'bg-primary-100 font-medium' : ''
                                                            } ${country.isPriority ? 'font-medium' : ''}`}
                                                        >
                                                            {country.label}
                                                        </button>
                                                    )
                                                ))
                                            ) : (
                                                <div className="px-4 py-3 text-sm text-gray-500 text-center">
                                                    No countries found
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div>
                            <label htmlFor="organisation" className="block text-xs text-main-text mb-1">Organisation Name</label>
                            <input id="organisation" type="text" name="organisation" onChange={handleInputChange} placeholder="Enter organisation name" className="w-full p-2.5 text-sm bg-[#F5F5F5] rounded-md placeholder-gray-400 focus:outline-none focus:ring-1 focus:ring-primary-600"/>
                        </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                         <div>
                            <label htmlFor="designation" className="block text-xs text-main-text mb-1">Designation</label>
                            <input id="designation" type="text" name="designation" onChange={handleInputChange} placeholder="Enter your designation" className="w-full p-2.5 text-sm bg-[#F5F5F5] rounded-md placeholder-gray-400 focus:outline-none focus:ring-1 focus:ring-primary-600"/>
                        </div>
                        <div>
                            <label htmlFor="linkedIn" className="block text-xs text-main-text mb-1">LinkedIn or alternative URL</label>
                            <input id="linkedIn" type="url" name="linkedIn" onChange={handleInputChange} placeholder="Paste URL here" className="w-full p-2.5 text-sm bg-[#F5F5F5] rounded-md placeholder-gray-400 focus:outline-none focus:ring-1 focus:ring-primary-600"/>
                        </div>
                    </div>

                    {/* Status Messages */}
                    {submitStatus === 'success' && (
                        <InlineAlert variant="success" className="mt-4">
                            Sign up request submitted successfully! We'll get back to you soon.
                        </InlineAlert>
                    )}
                    {submitStatus === 'error' && errorMessage && (
                        <InlineAlert variant="error" className="mt-4">{errorMessage}</InlineAlert>
                    )}
                </form>

                <div className="flex items-center gap-4 mt-8 max-w-sm mx-auto">
                    <button 
                        type="button"
                        onClick={() => {
                            // Track back button click
                            trackGTMEvent('request_invite_back_clicked', {
                                component: 'RequestInviteModal',
                                form_filled: isFormValid
                            });
                            handleModalClose('back');
                        }}
                        className="flex-1 flex items-center justify-center gap-2 px-4 py-2.5 text-sm font-medium text-grayscale-1400 bg-white border border-primary-600 rounded-full hover:bg-primary-100 transition-colors shadow-md"
                    >
                        <span className="text-grayscale-1300"><ArrowLeftIcon /></span>
                        Back
                    </button>
                    <button
                        type="button"
                        onClick={handleSubmit}
                        className="flex-1 flex items-center justify-center gap-2 px-4 py-2.5 text-sm font-medium rounded-full transition-colors shadow-md disabled:bg-primary-100 disabled:cursor-not-allowed disabled:text-primary-300 bg-primary-600 text-white hover:bg-primary-700"
                        disabled={!isFormValid || isSubmitting || submitStatus === 'success' || emailStatus === 'invalid' || emailStatus === 'checking'}
                    >
                        {isSubmitting ? 'Submitting...' : 
                         submitStatus === 'success' ? 'Submitted!' : 
                         emailStatus === 'checking' ? 'Checking...' :
                         emailStatus === 'exists' ? 'Login Instead' : 
                         'Sign Up'}
                        {!isSubmitting && emailStatus !== 'checking' && <span className={isFormValid && submitStatus !== 'success' ? 'text-white' : 'text-primary-300'}><AddIcon /></span>}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RequestInviteModal;